import axios from 'axios';

export default {
  getStorePre (tourIdx, nationIdx, categoryIdx, type, second) { // 얼리버드, 신규예정 스와이퍼 전용
    return new Promise((resolve, reject) => {
      axios.get(`/v5/store/pre`, {
        params: {
          time: second,
          tour_idx: tourIdx,
          nation_idx: nationIdx,
          category_idx: categoryIdx,
          type
        }
      }).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getStoreProgress (status, tourIdx, nationIdx, categoryIdx, type, page, second, hashtag) {
    return new Promise((resolve, reject) => {
      axios.get(`/v5/store`, {
        params: {
          status, // status: 얼리버드('earlybird') or 신규예정('ready') or 제작완료('forsale') 구분해서 조회, 안 보내면 전체
          time: second,
          tour_idx: tourIdx,
          nation_idx: nationIdx, // 나라
          category_idx: categoryIdx, // 스토리 1, 카톡 2, ...
          type, // class or program
          page,
          count: 20,
          hashtag
        }
      }).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getProduct (idx) {
    return new Promise((resolve, reject) => {
      axios.get(`/v3/store/${idx}`).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postStoreIdxBookmark (idx) { // 상품 찜
    return new Promise((resolve, reject) => {
      axios.post(`/v2/store/${idx}/bookmark`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postStoreIdxAlarm (idx) { // 신규예정 상품 알람 신청
    return new Promise((resolve, reject) => {
      axios.post(`/v3/store/${idx}/alarm`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postStoreIdxTalk (idx, content) { // 렛츠톡 작성
    return new Promise((resolve, reject) => {
      axios.post(`/v2/store/${idx}/talk`, {
        idx,
        contents: content,
        privacy: 'public',
      }).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postStoreIdxTalkIdxComment (storeIdx, talkIdx, content) { // 렛츠톡 댓글 작성
    return new Promise((resolve, reject) => {
      axios.post(`/v2/store/${storeIdx}/talk/${talkIdx}/comment`, {
        store_idx: storeIdx,
        talk_idx: talkIdx,
        contents: content
      }).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postStoreIdxTalkIdxLike (storeIdx, talkIdx) { // 렛츠톡 좋아요
    return new Promise((resolve, reject) => {
      axios.post(`/v2/store/${storeIdx}/talk/${talkIdx}/like`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postStoreIdxTalkIdxCommentIdxLike (storeIdx, talkIdx, commentIdx) { // 렛츠톡 댓글 좋아요
    return new Promise((resolve, reject) => {
      axios.post(`/v2/store/${storeIdx}/talk/${talkIdx}/comment/${commentIdx}/like`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postStoreIdxTalkIdxReport (storeIdx, talkIdx) { // 렛츠톡 신고
    return new Promise((resolve, reject) => {
      axios.post(`/v2/store/${storeIdx}/talk/${talkIdx}/report`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postStoreIdxTalkIdxCommentIdxReport (storeIdx, talkIdx, commentIdx) { // 렛츠톡 댓글 신고
    return new Promise((resolve, reject) => {
      axios.post(`/v2/store/${storeIdx}/talk/${talkIdx}/comment/${commentIdx}/report`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  deleteStoreIdxTalkIdx (storeIdx, talkIdx) { // 렛츠톡 삭제
    return new Promise((resolve, reject) => {
      axios.delete(`/v2/store/${storeIdx}/talk/${talkIdx}`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  deleteStoreIdxTalkIdxCommentIdx (storeIdx, talkIdx, commentIdx) { // 렛츠톡 댓글 삭제
    return new Promise((resolve, reject) => {
      axios.delete(`/v2/store/${storeIdx}/talk/${talkIdx}/comment/${commentIdx}`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getStoreIdxPackage (idx) { // 패키지 선택을 위해 상품 패키지 목록 가져오기
    return new Promise((resolve, reject) => {
      axios.get(`/v2/store/${idx}/package`).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getStoreIdxTalk (second, idx, page) { // 렛츠톡 목록
    return new Promise((resolve, reject) => {
      axios.get(`/v2/store/${idx}/talk`, {
        params: {
          time: second,
          page,
          count: 20,
        }
      }).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getStoreIdxTalkIdxComment (second, storeIdx, talkIdx, offset) { // 렛츠톡 댓글 목록
    return new Promise((resolve, reject) => {
      axios.get(`/v2/store/${storeIdx}/talk/${talkIdx}/comment`, {
        params: {
          time: second,
          offset,
          count: 5,
        }
      }).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getStoreIdxReview (second, idx, page) {
    return new Promise((resolve, reject) => {
      axios.get(`/v2/store/${idx}/review`, {
        params: {
          time: second,
          page,
          count: 20,
        }
      }).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getStorePayment (second, page) {
    return new Promise((resolve, reject) => {
      axios.get(`/v3/store/payment`, {
        params: {
          time: second,
          page,
          count: 10,
        }
      }).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postPaymentCancel (idx, cancelType, cancelMessage) { // 환불 요청 (paymentIdx), 슬랙으로 감
    return new Promise((resolve, reject) => {
      axios.post(`/v3/payment/${idx}/cancel`, {
        canceltype: cancelType,
        cancelmsg: cancelMessage,
      }).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  getStoreIdxReviewIdx (storeIdx, reviewIdx) { // 리뷰 상세
    return new Promise((resolve, reject) => {
      axios.get(`/v2/store/${storeIdx}/review/${reviewIdx}`).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postStoreIdxReview (storeIdx, contents, reviewScore) {
    return new Promise((resolve, reject) => {
      axios.post(`/v2/store/${storeIdx}/review`, {
        contents,
        review_score: reviewScore
      }).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postStorePayment (userIdx, storeIdx) { // 무료 상품 구매목록에 추가
    return new Promise((resolve, reject) => {
      axios.post(`/v3/store/payment`, {
        user_idx: userIdx,
        store_idx: storeIdx
      }).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  // 쿠폰 관련
  getPaymentCoupon (page) { // 쿠폰 목록 조회
    return new Promise((resolve, reject) => {
      axios.get(`/v3/payment/coupon`, { params: {
        page,
        count: 20
      }}).then((response) => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postPaymentCoupon (code) { // 쿠폰 등록
    return new Promise((resolve, reject) => {
      axios.post(`/v3/payment/coupon`, {
        code
      }).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  },
  postStoreSurvey (storeIdx, type, location, name, phone, birthday, channel, interestNation, studyPeriod, studyStartDate, question, schedule) { // 어학연수 상담폼 등록
    return new Promise((resolve, reject) => {
      axios.post(`/v6/consulting`, {
        store_idx: storeIdx,
        type: type,
        location: location,
        name: name,
        phone: phone,
        birthday: birthday,
        channel: channel,
        interest_nation: interestNation,
        study_period: studyPeriod,
        study_start_date: studyStartDate,
        schedule: schedule,
        question: question,
        agree_privacy: 1,
      }).then(response => {
        if (response.data) resolve(response.data);
        reject(response);
      }).catch(reject);
    });
  }
};
